import Redux from 'redux';
import * as Bixby from '$/core';
import {
  ALL_CLO_DEAL_HOLDING_FOR_BIXBYID_MAPPING_FAILURE,
  ALL_CLO_DEAL_HOLDING_FOR_BIXBYID_MAPPING_LOADING,
  ALL_CLO_DEAL_HOLDING_FOR_BIXBYID_MAPPING_SUCCESS,
  CloDealActionTypes,
  CloDealHoldingForBixbyIdMappingState,
} from './types';

const initialState: CloDealHoldingForBixbyIdMappingState = {
  isLoading: false,
  error: undefined,
  cloDealHoldingForBixbyIdMappings: undefined,
};

const cloDealHoldingFOrBixbyIdMappingReducer: Redux.Reducer<CloDealHoldingForBixbyIdMappingState> = (state = initialState, action: CloDealActionTypes): CloDealHoldingForBixbyIdMappingState => {
  switch (action.type) {
    case ALL_CLO_DEAL_HOLDING_FOR_BIXBYID_MAPPING_LOADING:
      return {
        ...state,
        isLoading: true,
      };
    case ALL_CLO_DEAL_HOLDING_FOR_BIXBYID_MAPPING_SUCCESS:
      return {
        ...state,
        isLoading: false,
        cloDealHoldingForBixbyIdMappings: action.payload
      };
    case ALL_CLO_DEAL_HOLDING_FOR_BIXBYID_MAPPING_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload as Bixby.Models.BixbyError,
      };
    default:
      return state;
  }
};

export default cloDealHoldingFOrBixbyIdMappingReducer;
